import React from "react";
import styled, { css } from "styled-components";
import { ImageSection } from "@domain/lms/article/article";
import { DetailedArticle } from "@domain/lms/article/dtos";
import { getAssetById } from "@domain/lms/article/utils";
import { ImageVersions } from "@domain/media/dtos";
import { ImageView } from "@ui/components/media/imageView";

interface ImageSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: ImageSection;
	article: DetailedArticle;
}
export const ImageSectionView: React.FC<ImageSectionViewProps> = ({ section, article, ...htmlProps }) => {
	const asset = getAssetById(article.content, section.assetId);
	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<ImageView image={asset} imageStyle={imageStyle} imageVersion={ImageVersions.LARGE} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const imageStyle = css`
	width: auto;
	max-width: 100%;
	max-height: 400px;
`;
